

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardForm } from '../../widgets/Cards';
import { editMHSafety, newMHSafety, fetchMHSafetys } from '../../../actions';

class MHSafety extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchMHSafetys(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchMHSafetys(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].mentalhealth;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
    MHSafetyForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;

        // Change Actions below
            this.props.newMHSafety(form);
        }

        const required = value =>(value ? undefined : 'Required');

        const formButton = () => {
            var permit = this.props.selectedPermission.permission[0].mentalhealth;
            if (permit === "View only") {
                return "visible";
            } else { 
                return "hidden";
            }  
        }


// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Safety Plan</div>

                            <div className='form-2-columns'>
                                <div>
                                <Field name="date" component='input' label="Date" validate={required}>
                                    {({input, meta}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Date</label>
                                                <input size='30' {...input} type='date' />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                    )} 
                                </Field>
                                <Field name='reason' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>My Reason to Live</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='cando' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>What can I do to keep me safe</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='help' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Where to seek help</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                                <div>
                                <Field name='call' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>People I can call</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='talk' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>People I can talk to</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='professional' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Professional Help I can contact</label>
                                            <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                </div>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' style={{visibility:formButton()}} disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' style={{visibility:formButton()}} onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button type='button' style={{visibility:formButton()}} onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardForm content={this.MHSafetyForm()}>
            </CardForm>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.mh_safetys),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editMHSafety, newMHSafety, fetchMHSafetys})(MHSafety);
